var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoExclamationOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#F0A14E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88102 13.58L9.60102 4H12.341L12.041 13.58H9.88102ZM11.021 18.14C10.541 18.14 10.1477 17.9933 9.84102 17.7C9.54768 17.4067 9.40102 17.0533 9.40102 16.64C9.40102 16.2133 9.54768 15.8533 9.84102 15.56C10.1477 15.2667 10.541 15.12 11.021 15.12C11.4743 15.12 11.8477 15.2667 12.141 15.56C12.4477 15.8533 12.601 16.2133 12.601 16.64C12.601 17.0533 12.4477 17.4067 12.141 17.7C11.8477 17.9933 11.4743 18.14 11.021 18.14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoExclamationOrange);
export default __webpack_public_path__ + "static/media/picto_exclamation_orange.501e1b20627aba845bca3ca2d546b994.svg";
export { ForwardRef as ReactComponent };